<template>
  <div>
    <div
      class="video-wrapper"
      :class="footer ? 'footer' : ''"
    >
      <div class="min-w-full min-h-full flex flex-wrap justify-center items-center content-center text-center py-10 md:py-0">
        <t-container class="text-white video-title px-4">
          <h1 class="text-white md:text-6xl pb-3">
            <slot name="title" />
          </h1>
          <p class="text-white md:text-2xl">
            <slot name="text" />
          </p>
          <slot />
        </t-container>
      </div>
      <video
        autoplay
        loop
        muted
        playsinline
        class="w-full"
      >
        <source
          :src="backgroundUrl"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoHero',
  props: {
    backgroundUrl: {
      type: String,
      default: '//d2vu1vyohnm3g3.cloudfront.net/home-video/summit-ceu-course-examples-3.mp4?crop=entropy&fit=crop&h=200&w=600',
    },
    footer: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
@media only screen and (width >= 820px) {
  .video-wrapper {
    position: relative;
    background: rgb(0 0 0 / 55%);
    width: 100%;
    height: 600px;
    overflow: hidden;
  }

  .video-wrapper.footer {
    height: 400px !important;
    background: rgb(0 0 0 / 45%) !important;
  }

  .video-wrapper video {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    z-index: -10;
    pointer-events: none;
  }

  .video-title {
    z-index: 1;
    position: absolute;
    top: 22%;
  }
}

@media only screen and (width <= 820px) {
  .video-wrapper {
    position: relative;
    background: rgb(0 0 0 / 55%);
    width: 100%;
    height: 600px;
    overflow: hidden;
  }

  .video-wrapper video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 725px;
    object-fit: cover;
    z-index: -1;
    pointer-events: none;
  }
}
</style>
